export const colorWarning = 'colorWarning';
